export default "__VITE_ASSET__BWhE0ZwL__"